import apiHelper from '../helpers/apiHelper'
import VueCookie from 'vue-cookie'
import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  getInvestor()
  {
    return apiHelper.request('investor', {}, 'GET', this.mauticProcessing({}))
  },
  create(data)
  {
    data = this.processing(data)
    return apiHelper.request('investor', data, 'POST')
  },
  update(data)
  {
    data = this.processing(data)
    return apiHelper.request('investor', data, 'PUT')
  },
  setSettings(settings)
  {
    return apiHelper.request('settings', settings, 'PUT')
  },
  getSettings()
  {
    return apiHelper.request('settings')
  },
  getCurrencies()
  {
    return apiHelper.request('classificators/CURRENCY')
  },
  getDepositMethods()
  {
    return apiHelper.request('deposit-methods')
  },
  getAccountList()
  {
    return apiHelper.request('investor-account-list')
  },
  setWithdraw(data)
  {
    // Explicit timeout so a withdrawal can never hang the UI forever: the backend commit is
    // normally seconds but can stretch under ledger-helper contention. On timeout the request
    // MAY still have committed server-side — the caller shows the "unconfirmed" message.
    return apiHelper.request('investor-withdrawal', data, 'POST', {}, false, {timeout: 90000})
  },
  getInvestorDetails()
  {
    return apiHelper.request('investor-details')
  },
  getAccountStatement(start, end, pdfResponse = 0)
  {
    return apiHelper.request('account-statement/' + start + '/' + end + '/' + pdfResponse)
  },
  processing(data)
  {
    data = this.mauticProcessing(data)
    // Only for already login investors
    if (localStorage.getItem('accessToken') !== null)
    {
      data = this.mediaResourcesProcessing(data)
    }
    return data
  },
  mauticProcessing(data)
  {
    const mauticId = VueCookie.get('mtc_id')
    const mauticDeviceId = VueCookie.get('mautic_device_id')
    if (mauticId)
    {
      data.mautic_id = mauticId
      data.mautic_device_id = mauticDeviceId
    }
    return data
  },
  mediaResourcesProcessing(data)
  {
    // console.log('mediaResourcesProcessing: running')
    const utmTags = localStorageHelper.getJson('utm_tags')
    const referrerUrl = localStorageHelper.get('referrerUrl')
    if (utmTags && Object.keys(utmTags).length > 0)
    {
      data.utm_tags = utmTags
      // localStorageHelper.remove('utm_tags')
    }
    if (referrerUrl)
    {
      data.referrerUrl = referrerUrl
      // localStorageHelper.remove('referrerUrl')
    }
    // console.log('data:', data)
    return data
  },
  getNotificationSettings(id, hash)
  {
    return apiHelper.request('investor-notification-settings/' + id + '/' + hash)
  },
  setNotificationSettings(id, hash, data)
  {
    return apiHelper.request('investor-notification-settings/' + id + '/' + hash, data, 'POST')
  }
}
